import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Sparklines, SparklinesLine, SparklinesSpots } from "react-sparklines";
import moment from "moment";
import { connect } from "react-redux";
import { schakelkwhnmeter, bulkSchakelkwhnmeter } from "../Reducers/actions";

class SensorWidget extends React.Component {
  state = {
    errors: {},
    load: false,
    bulkAction: false,
    selectedSensors: [],
    bulkMessage: null,
  };

  handleItem(item) {
    this.props.Verwerken({ id: item._id }).then((datav) => {
      this.getvals({});
    });
  }

  handleBulkSchakelen = async (schakelen) => {
    const { selectedSensors } = this.state;
    if (selectedSensors.length === 0) {
      this.setState({ 
        bulkMessage: { 
          type: 'warning', 
          text: 'Selecteer eerst sensoren om een bulk actie uit te voeren' 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 5000);
      return;
    }

    this.setState({ bulkAction: true, bulkMessage: null });

    try {
      const result = await this.props.bulkSchakelkwhnmeter(selectedSensors, schakelen);
      
      if (result.status === 'processing') {
        this.setState({ 
          bulkMessage: { 
            type: 'success', 
            text: `${result.message} - De actie wordt op de achtergrond uitgevoerd met 20 seconden vertraging tussen elke sensor.` 
          } 
        });
        setTimeout(() => this.setState({ bulkMessage: null }), 10000);
      }
      
    } catch (error) {
      this.setState({ 
        bulkMessage: { 
          type: 'danger', 
          text: `Er is een fout opgetreden bij de bulk actie: ${error.message}` 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 8000);
    }

    this.setState({ bulkAction: false, selectedSensors: [] });
  }

  handleSelectSensor = (sensorId, checked) => {
    this.setState(prevState => {
      let newSelected;
      if (checked) {
        newSelected = [...prevState.selectedSensors, sensorId];
      } else {
        newSelected = prevState.selectedSensors.filter(id => id !== sensorId);
      }
      return { selectedSensors: newSelected };
    }, () => {
      this.forceUpdate();
    });
  }

  handleSelectAll = (checked) => {
    const { sensoren } = this.props;
    if (checked) {
      this.setState({ selectedSensors: sensoren.map(sensor => sensor._id) });
    } else {
      this.setState({ selectedSensors: [] });
    }
  }

  render() {
    function seturl(sen, id) {
      if (sen === "temperatuur") {
        return "/sensoren/sensor/show/" + id;
      } else if (sen === "gas") {
        return "/sensoren/sensor/gas/show/" + id;
      } else if (sen === "electra") {
        return "/sensoren/sensor/electra/show/" + id;
      } else if (sen === "water") {
        return "/sensoren/sensor/water/show/" + id;
      } else if (sen === "ampere") {
        return "/sensoren/sensor/amp/show/" + id;
      }
    }
    const { selectedSensors, bulkMessage } = this.state;

    const columns = [
      {
        dataField: "select",
        text: (
          <input
            type="checkbox"
            onChange={(e) => {
              e.stopPropagation();
              this.handleSelectAll(e.target.checked);
            }}
            onClick={(e) => e.stopPropagation()}
            checked={selectedSensors.length === this.props.sensoren.length && this.props.sensoren.length > 0}
          />
        ),
        formatter: (cellContent, row) => {
          const isSelected = selectedSensors.includes(row._id);
          
          return (
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => {
                this.handleSelectSensor(row._id, e.target.checked);
              }}
              disabled={this.state.bulkAction}
            />
          );
        },
        headerAlign: "left",
        align: "left",
        sort: false,
      },
      {
        dataField: "naam",
        text: "Naam Sensor",
        sort: true,
        formatter: (cellContent, row) => {
          if (cellContent.NL) {
            return cellContent.NL;
          } else {
            return cellContent;
          }
        },
        sortValue: (cell, row) => {
          if (cell.NL) {
            return cell.NL;
          } else {
            return cell;
          }
        },
      },
      {
        dataField: "lastcheck",
        text: "Laatste data",
        sort: true,
        formatter: (cellContent, row) => {
          if (row.electradatas && row.electradatas[0]) return moment(row.electradatas[0].datum).fromNow();
          if (row.sensordatas && row.sensordatas[0]) return moment(row.sensordatas[0].datum).fromNow();
        },
        sortValue: (cell, row) => {
          if (row.electradatas && row.electradatas[0]) return new Date(row.electradatas[0].datum);
          if (row.sensordatas && row.sensordatas[0]) return new Date(row.sensordatas[0].datum);
          return new Date(0);
        },
      },
      {
        text: "Status",
        dataField: "status",
        sort: true,
        formatter: (cellContent, row) => {
          if (row.active ) {
          if (cellContent === "false") {
            return <span className="badge badge-danger">Er is een storing</span>;
          } else {
            return <span className="badge badge-success">Sensor werkt goed</span>;
          }
        } else {
          return <span className="badge badge-warning">Sensor is uitgeschakeld</span>;
        }
        },
        sortValue: (cell, row) => {
          if (!row.active) return 0; // Uitgeschakeld
          if (cell === "false") return 1; // Storing
          return 2; // Werkt goed
        },
      },
      {
        text: "Schakelstatus",
        dataField: "schakelstatus",
        sort: true,
        formatter: (cellContent, row) => {
          // Check if sensor has recent electra data to determine switch status
          const hasRecentData = row.electradatas && row.electradatas.length > 0;
          
          if (!hasRecentData) {
            return <span className="badge badge-secondary">Onbekend</span>;
          }

          // Get the most recent electra data
          const recentData = row.electradatas[0];
          const isOn = recentData.value && recentData.value > 0;
          
          if (isOn) {
            return <span className="badge badge-success">Ingeschakeld</span>;
          } else {
            return <span className="badge badge-danger">Uitgeschakeld</span>;
          }
        },
        sortValue: (cell, row) => {
          const hasRecentData = row.electradatas && row.electradatas.length > 0;
          if (!hasRecentData) return 0; // Onbekend
          
          const recentData = row.electradatas[0];
          const isOn = recentData.value && recentData.value > 0;
          return isOn ? 2 : 1; // Ingeschakeld = 2, Uitgeschakeld = 1
        },
      },
      {
        text: "Boeking",
        dataField: "bookingStatus",
        sort: true,
        formatter: (cellContent, row) => {
          const hasBooking = row.hasActiveBooking;
          const boekingInfo = row.boekingInfo && row.boekingInfo[0];
          
          if (!hasBooking || !boekingInfo) {
            return <span className="badge badge-secondary">Geen boeking</span>;
          }

          // Check if booking is paid
          const isPaid = row.boeking && row.boeking.betaald;
          const guestName = boekingInfo.naam || boekingInfo.gastinfo?.achternaam || 'Onbekende gast';
          
          if (isPaid) {
            return (
              <span className="badge badge-success" title={`Geboekt door: ${guestName}`}>
                Geboekt & Betaald
              </span>
            );
          } else {
            return (
              <span className="badge badge-warning" title={`Geboekt door: ${guestName}`}>
                Geboekt - Niet betaald
              </span>
            );
          }
        },
        sortValue: (cell, row) => {
          if (!row.hasActiveBooking) return 0; // Geen boeking
          const isPaid = row.boeking && row.boeking.betaald;
          return isPaid ? 3 : 2; // Betaald = 3, Niet betaald = 2, Geen boeking = 0
        },
      },
      {
        dataField: "data",
        text: "Waardes",
        formatter: (cellContent, row) => {
          const data = [];
          const MAX_DATA_POINTS = 50; // Limit to prevent array length errors

          if (row.sensordatas && row.sensordatas.length > 0) {
            // Take only the most recent data points
            const recentData = row.sensordatas.slice(0, MAX_DATA_POINTS);
            recentData.forEach(function (a) {
              if (a.value !== undefined && a.value !== null) {
                data.push(a.value);
              }
            });
          }

          if (row.electradatas && row.electradatas.length > 0) {
            // Take only the most recent data points
            const recentData = row.electradatas.slice(0, MAX_DATA_POINTS);
            recentData.forEach(function (a, key) {
              if (key > 0 && a.value !== undefined && a.value !== null) {
                const diff = Number(recentData[key - 1].value - Number(a.value));
                if (!isNaN(diff) && isFinite(diff)) {
                  data.push(diff);
                }
              }
            });
          }

          // Only render if we have valid data
          if (data.length === 0) {
            return <span className="text-muted">Geen data</span>;
          }

          return (
            <Sparklines data={data.reverse()} margin={5} height={30}>
              <SparklinesLine style={{ strokeWidth: 1.5, stroke: "#d96a29", fill: "none" }} />
              <SparklinesSpots size={3} style={{ stroke: "#d96a29", strokeWidth: 1.5, fill: "white" }} />
            </Sparklines>
          );
        },
      },
      {
        text: "Bekijken",
        dataField: "soort",
        headerAlign: "center",
        align: "center",
        sort: true,
        formatter: (cellContent, row) => {
          return (
            <Link className="btn btn-sm btn-success" to={{ pathname: seturl(cellContent, row._id) }}>
              Bekijken
            </Link>
          );
        },
      },
    ];
    const { sensoren } = this.props;
    const { SearchBar } = Search;

    return (
      <ToolkitProvider
        keyField="_id"
        data={sensoren}
        columns={columns}
        search={{
          searchFormatted: true,
        }}
      >
        {(props) => (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <SearchBar placeholder="Zoeken" {...props.searchProps} />
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {selectedSensors.length > 0 && (
                  <>
                    <span className="badge badge-info">{selectedSensors.length} geselecteerd</span>
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => this.handleBulkSchakelen(true)}
                      disabled={this.state.bulkAction}
                    >
                      {this.state.bulkAction ? 'Bezig...' : 'Alle inschakelen'}
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => this.handleBulkSchakelen(false)}
                      disabled={this.state.bulkAction}
                    >
                      {this.state.bulkAction ? 'Bezig...' : 'Alle uitschakelen'}
                    </button>
                  </>
                )}
              </div>
            </div>
            {bulkMessage && (
              <div className={`alert alert-${bulkMessage.type}`}>
                {bulkMessage.text}
              </div>
            )}
            {this.state.bulkAction && (
              <div className="alert alert-info">
                <strong>Bulk actie wordt gestart...</strong><br />
                De server verwerkt de sensors op de achtergrond met 20 seconden vertraging.
              </div>
            )}
            <BootstrapTable 
              key={selectedSensors.length} 
              wrapperClasses="table-responsive-md" 
              pagination={paginationFactory()} 
              selectRow={{ 
                mode: 'checkbox',
                clickToSelect: false,
                hideSelectColumn: true
              }}
              {...props.baseProps} 
            />
          </div>
        )}
      </ToolkitProvider>
    );
  }
}

export default connect(null, { schakelkwhnmeter, bulkSchakelkwhnmeter })(SensorWidget);
